// extracted by mini-css-extract-plugin
module.exports = {"messageBox":"Message_messageBox__1TRBL","message":"Message_message__3UVp7","orderId":"Message_orderId__MJlf9"};